const breakpoints = {
    mobile: '720px'
}

export default {
  breakpoints 
}
